// Container.tsx
import cn from 'classnames';
import styles from './Container.module.scss';

type Props = {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    max?: number | string; // 1200 | '1200px'
    padX?: number | string; // 0 | '35px'
    fluid?: boolean;
};

const toPx = (v?: number | string) => (typeof v === 'number' ? `${v}px` : v);

export default function Container({
    children,
    className,
    style,
    max,
    padX,
    fluid,
}: Props) {
    const vars: React.CSSProperties = {
        ...(max != null ? { ['--container-max' as any]: toPx(max) } : {}),
        ...(padX != null ? { ['--container-pad-x' as any]: toPx(padX) } : {}),
    };

    return (
        <div
            className={cn(
                styles.container,
                fluid && styles['container--fluid'],
                className
            )}
            style={{ ...vars, ...style }}
        >
            {children}
        </div>
    );
}
